import PropTypes from 'prop-types';
import React from 'react';
import { View } from 'react-native';
/* eslint-disable import/first, import/no-unresolved, import/no-webpack-loader-syntax, import/no-extraneous-dependencies */
import loadAllAboard from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconAllAboard';
import loadBestBuddy from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconBestBuddy';
import loadBigIdea from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconBigIdea';
import loadBoostFluency from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconBoostFluency';
import loadBookClub from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconBookClub';
import loadCityPlanner from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCityPlanner';
import loadCodex from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCodeX';
import loadConnectIt from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconConnectIt';
import loadCuriosoCrossing from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCuriosoCrossing';
import loadCuriosoCalling from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCuriosoCalling';
import loadCuriousCases from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCuriousCases';
import loadCutItOut from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconCutItOut';
import loadDebateABall from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconDebateABall';
import loadDirectorsCut from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconDirectorsCut';
import loadEstaOAquella from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconEstaOAquella';
import loadEReader from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconEReader';
import loadFieldObserver from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconFieldObserver';
import loadFoodTruck from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconFoodTruck';
import loadFoodTruckChefsSpecial from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconFoodTruckChefsSpecial';
import loadFotoFotoCognado from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconFotoFotoCognado';
import loadGameUnknown from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconUnknown';
import loadGameWIP from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWIP';
import loadGemNyeFriends from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconGemNyeFriends';
import loadGrumpyGoblins from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconGrumpyGoblins';
import loadHangryGoblin from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconHangryGoblin';
import loadIdiomatica from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconIdiomatica';
import loadInkBlott from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconInkBlott';
import loadJuegaYConjuga from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconJuegaYConjuga';
import loadLaRanaBrincacharcos from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconLaRanaBrincacharcos';
import loadMessageInABottle from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconMessageInABottle';
import loadMindTheGap from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconMindTheGap';
import loadNewsflash from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconNewsflash';
import loadPickyGoblins from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconPickyGoblins';
import loadPictureThis from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconPictureThis';
import loadPoetsPath from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconPoetsPath';
import loadPunchline from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconPunchline';
import loadReadAllAboutIt from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconReadAllAboutIt';
import loadRhymeTime from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconRhymeTime';
import loadShadesOfMeaning from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconShadesOfMeaning';
import loadShowOff from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconShowOff';
import loadSilabalon from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconSilabalon';
import loadSilabalonLaCopa from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconSilabalonLaCopa';
import loadSloppyScrolls from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconSloppyScrolls';
import loadSortItOut from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconSortItOut';
import loadStickerBook from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconStickerBook';
import loadStoryboard from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconStoryboard';
import loadStorybox from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconStorybox';
import loadStoryLabIcon from 'bundle-loader?lazy&name=[name]!./GameIcons/StoryLabIcon';
import loadSuperMatch from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconSuperMatch';
import loadThisThat from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconThisThat';
import loadTongueTwist from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconTongueTwist';
import loadTubeTales from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconTubeTales';
import loadUnmaskThat from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconUnmaskThat';
import loadWildPlanet from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWildPlanet';
import loadWordbots from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWordbots';
import loadWordCity from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWordCity';
import loadPlanTorres from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconPlanTorres';
import loadWordRaiders from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWordRaiders';
import loadWordSlide from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconWordSlide';
import loadYearbook from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconYearbook';
import loadZoomBoom from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconZoomBoom';
import loadMissionIcon1 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon1';
import loadMissionIcon2 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon2';
import loadMissionIcon3 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon3';
import loadMissionIcon4 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon4';
import loadMissionIcon5 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon5';
import loadMissionIcon6 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon6';
import loadMissionIcon7 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon7';
import loadMissionIcon8 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon8';
import loadMissionIcon9 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon9';
import loadMissionIcon10 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon10';
import loadMissionIcon11 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon11';
import loadMissionIcon12 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon12';
import loadMissionIcon13 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon13';
import loadMissionIcon14 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon14';
import loadMissionIcon15 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon15';
import loadMissionIcon16 from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIcon16';
import loadMissionIconDefault from 'bundle-loader?lazy&name=[name]!./TFEIcons/MissionIconDefault';
import loadVocab from 'bundle-loader?lazy&name=[name]!./GameIcons/GameIconVocab';
/* eslint-enable import/first, import/no-unresolved, import/no-webpack-loader-syntax, import/no-extraneous-dependencies */
import GameIds from '../../data/GameIds';
import Bundle from '../../../components/Bundle';

const GameIcon = ({ gameId, width, height }) => {
  let gameIconComponent = <View />;
  if (gameId && gameId.includes('ereader')) {
    gameIconComponent = (
      <Bundle load={loadEReader} showLoader={false}>
        {EReader => <EReader height={height} width={width} />}
      </Bundle>
    );
  } else if (/close_reading_episode/.test(gameId)) {
    switch (gameId) {
      case 'close_reading_episode01':
        gameIconComponent = (
          <Bundle load={loadMissionIcon1} showLoader={false}>
            {MissionIcon1 => <MissionIcon1 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode02':
        gameIconComponent = (
          <Bundle load={loadMissionIcon2} showLoader={false}>
            {MissionIcon2 => <MissionIcon2 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode03':
        gameIconComponent = (
          <Bundle load={loadMissionIcon3} showLoader={false}>
            {MissionIcon3 => <MissionIcon3 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode04':
        gameIconComponent = (
          <Bundle load={loadMissionIcon4} showLoader={false}>
            {MissionIcon4 => <MissionIcon4 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode05':
        gameIconComponent = (
          <Bundle load={loadMissionIcon5} showLoader={false}>
            {MissionIcon5 => <MissionIcon5 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode06':
        gameIconComponent = (
          <Bundle load={loadMissionIcon6} showLoader={false}>
            {MissionIcon6 => <MissionIcon6 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode07':
        gameIconComponent = (
          <Bundle load={loadMissionIcon7} showLoader={false}>
            {MissionIcon7 => <MissionIcon7 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode08':
        gameIconComponent = (
          <Bundle load={loadMissionIcon8} showLoader={false}>
            {MissionIcon8 => <MissionIcon8 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode09':
        gameIconComponent = (
          <Bundle load={loadMissionIcon9} showLoader={false}>
            {MissionIcon9 => <MissionIcon9 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode10':
        gameIconComponent = (
          <Bundle load={loadMissionIcon10} showLoader={false}>
            {MissionIcon10 => <MissionIcon10 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode11':
        gameIconComponent = (
          <Bundle load={loadMissionIcon11} showLoader={false}>
            {MissionIcon11 => <MissionIcon11 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode12':
        gameIconComponent = (
          <Bundle load={loadMissionIcon12} showLoader={false}>
            {MissionIcon12 => <MissionIcon12 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode13':
        gameIconComponent = (
          <Bundle load={loadMissionIcon13} showLoader={false}>
            {MissionIcon13 => <MissionIcon13 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode14':
        gameIconComponent = (
          <Bundle load={loadMissionIcon14} showLoader={false}>
            {MissionIcon14 => <MissionIcon14 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode15':
        gameIconComponent = (
          <Bundle load={loadMissionIcon15} showLoader={false}>
            {MissionIcon15 => <MissionIcon15 height={height} width={width} />}
          </Bundle>
        );
        break;
      case 'close_reading_episode16':
        gameIconComponent = (
          <Bundle load={loadMissionIcon16} showLoader={false}>
            {MissionIcon16 => <MissionIcon16 height={height} width={width} />}
          </Bundle>
        );
        break;
      default:
        gameIconComponent = (
          <Bundle load={loadMissionIconDefault} showLoader={false}>
            {MissionIcon00 => <MissionIcon00 height={height} width={width} />}
          </Bundle>
        );
    }
  } else {
    switch (gameId) {
      case 'GameUnknown':
        gameIconComponent = (
          <Bundle load={loadGameUnknown} showLoader={false}>
            {GameUnknown => <GameUnknown height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.ALL_ABOARD:
        gameIconComponent = (
          <Bundle load={loadAllAboard} showLoader={false}>
            {AllAboard => <AllAboard height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.BEST_BUDDY:
        gameIconComponent = (
          <Bundle load={loadBestBuddy} showLoader={false}>
            {BestBuddy => <BestBuddy height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WHATS_THE_BIG_IDEA:
        gameIconComponent = (
          <Bundle load={loadBigIdea} showLoader={false}>
            {BigIdea => <BigIdea height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.BOOK_CLUB:
        gameIconComponent = (
          <Bundle load={loadBookClub} showLoader={false}>
            {BookClub => <BookClub height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CITY_PLANNER:
        gameIconComponent = (
          <Bundle load={loadCityPlanner} showLoader={false}>
            {CityPlanner => <CityPlanner height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CONNECT_IT:
        gameIconComponent = (
          <Bundle load={loadConnectIt} showLoader={false}>
            {ConnectIt => <ConnectIt height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CURIOUS_CASES:
        gameIconComponent = (
          <Bundle load={loadCuriousCases} showLoader={false}>
            {CuriousCases => <CuriousCases height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.DEBATE_A_BALL:
        gameIconComponent = (
          <Bundle load={loadDebateABall} showLoader={false}>
            {DebateABall => <DebateABall height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.DIRECTORS_CUT:
        gameIconComponent = (
          <Bundle load={loadDirectorsCut} showLoader={false}>
            {DirectorsCut => <DirectorsCut height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.ESTA_O_AQUELLA:
        gameIconComponent = (
          <Bundle load={loadEstaOAquella} showLoader={false}>
            {EstaOAquella => <EstaOAquella height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.JUEGA_Y_CONJUGA:
        gameIconComponent = (
          <Bundle load={loadJuegaYConjuga} showLoader={false}>
            {JuegaYConjuga => <JuegaYConjuga height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SILABALON_LA_COPA:
        gameIconComponent = (
          <Bundle load={loadSilabalonLaCopa} showLoader={false}>
            {SilabalonLaCopa => <SilabalonLaCopa height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SLOPPY_SCROLLS:
        gameIconComponent = (
          <Bundle load={loadSloppyScrolls} showLoader={false}>
            {SloppyScrolls => <SloppyScrolls height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.LA_RANA_BRINCACHARCOS:
        gameIconComponent = (
          <Bundle load={loadLaRanaBrincacharcos} showLoader={false}>
            {LaRanaBrincacharcos => <LaRanaBrincacharcos height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.MESSAGE_IN_A_BOTTLE:
        gameIconComponent = (
          <Bundle load={loadMessageInABottle} showLoader={false}>
            {MessageInABottle => <MessageInABottle height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.NEWSFLASH:
        gameIconComponent = (
          <Bundle load={loadNewsflash} showLoader={false}>
            {Newsflash => <Newsflash height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.PICKY_GOBLINS:
        gameIconComponent = (
          <Bundle load={loadPickyGoblins} showLoader={false}>
            {PickyGoblins => <PickyGoblins height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.STORYBOARD:
        gameIconComponent = (
          <Bundle load={loadStoryboard} showLoader={false}>
            {Storyboard => <Storyboard height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.STORYBOX:
        gameIconComponent = (
          <Bundle load={loadStorybox} showLoader={false}>
            {Storybox => <Storybox height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CUT_IT_OUT:
        gameIconComponent = (
          <Bundle load={loadCutItOut} showLoader={false}>
            {CutItOut => <CutItOut height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CURIOSO_CROSSING:
        gameIconComponent = (
          <Bundle load={loadCuriosoCrossing} showLoader={false}>
            {CuriosoCrossing => <CuriosoCrossing height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CURIOSO_CALLING:
        gameIconComponent = (
          <Bundle load={loadCuriosoCalling} showLoader={false}>
            {CuriosoCalling => <CuriosoCalling height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.E_READER:
        gameIconComponent = (
          <Bundle load={loadEReader} showLoader={false}>
            {EReader => <EReader height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.FOOD_TRUCK:
        gameIconComponent = (
          <Bundle load={loadFoodTruck} showLoader={false}>
            {FoodTruck => <FoodTruck height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.FOOD_TRUCK_CHEFS_SPECIALS:
        gameIconComponent = (
          <Bundle load={loadFoodTruckChefsSpecial} showLoader={false}>
            {FoodTruckChefsSpecial => <FoodTruckChefsSpecial height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.FOTO_FOTO_COGNADO:
        gameIconComponent = (
          <Bundle load={loadFotoFotoCognado} showLoader={false}>
            {FotoFotoCognado => <FotoFotoCognado height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.GEM_NYE_FRIENDS:
        gameIconComponent = (
          <Bundle load={loadGemNyeFriends} showLoader={false}>
            {GemNyeFriends => <GemNyeFriends height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.GRUMPY_GOBLINS:
        gameIconComponent = (
          <Bundle load={loadGrumpyGoblins} showLoader={false}>
            {GrumpyGoblins => <GrumpyGoblins height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.HANGRY_GOBLINS:
        gameIconComponent = (
          <Bundle load={loadHangryGoblin} showLoader={false}>
            {HangryGoblin => <HangryGoblin height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.IDIOMATICA:
        gameIconComponent = (
          <Bundle load={loadIdiomatica} showLoader={false}>
            {Idiomatica => <Idiomatica height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.INKBLOTT:
        gameIconComponent = (
          <Bundle load={loadInkBlott} showLoader={false}>
            {InkBlott => <InkBlott height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.MIND_THE_GAP:
        gameIconComponent = (
          <Bundle load={loadMindTheGap} showLoader={false}>
            {MindTheGap => <MindTheGap height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.PUNCHLINE:
        gameIconComponent = (
          <Bundle load={loadPunchline} showLoader={false}>
            {Punchline => <Punchline height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.PICTURE_THIS:
        gameIconComponent = (
          <Bundle load={loadPictureThis} showLoader={false}>
            {PictureThis => <PictureThis height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.POETS_PATH:
        gameIconComponent = (
          <Bundle load={loadPoetsPath} showLoader={false}>
            {PoetsPath => <PoetsPath height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.RHYME_TIME:
        gameIconComponent = (
          <Bundle load={loadRhymeTime} showLoader={false}>
            {RhymeTime => <RhymeTime height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.READ_ALL_ABOUT_IT:
        gameIconComponent = (
          <Bundle load={loadReadAllAboutIt} showLoader={false}>
            {ReadAllAboutIt => <ReadAllAboutIt height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SHADES_OF_MEANING:
        gameIconComponent = (
          <Bundle load={loadShadesOfMeaning} showLoader={false}>
            {ShadesOfMeaning => <ShadesOfMeaning height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SHOW_OFF:
        gameIconComponent = (
          <Bundle load={loadShowOff} showLoader={false}>
            {ShowOff => <ShowOff height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SILABALON:
        gameIconComponent = (
          <Bundle load={loadSilabalon} showLoader={false}>
            {Silabalon => <Silabalon height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.STICKER_BOOK:
        gameIconComponent = (
          <Bundle load={loadStickerBook} showLoader={false}>
            {StickerBook => <StickerBook height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SUPER_MATCH:
        gameIconComponent = (
          <Bundle load={loadSuperMatch} showLoader={false}>
            {SuperMatch => <SuperMatch height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.BECAUSE_THIS_THAT:
        gameIconComponent = (
          <Bundle load={loadThisThat} showLoader={false}>
            {ThisThat => <ThisThat height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.TONGUE_TWIST:
        gameIconComponent = (
          <Bundle load={loadTongueTwist} showLoader={false}>
            {TongueTwist => <TongueTwist height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.TUBE_TALES:
        gameIconComponent = (
          <Bundle load={loadTubeTales} showLoader={false}>
            {TubeTales => <TubeTales height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.UNMASK_THAT:
        gameIconComponent = (
          <Bundle load={loadUnmaskThat} showLoader={false}>
            {UnmaskThat => <UnmaskThat height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WORDBOTS:
        gameIconComponent = (
          <Bundle load={loadWordbots} showLoader={false}>
            {Wordbots => <Wordbots height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WORD_CITY:
        gameIconComponent = (
          <Bundle load={loadWordCity} showLoader={false}>
            {WordCity => <WordCity height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.PLANTORRES:
        gameIconComponent = (
          <Bundle load={loadPlanTorres} showLoader={false}>
            {PlanTorres => <PlanTorres height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WORD_SLIDE:
        gameIconComponent = (
          <Bundle load={loadWordSlide} showLoader={false}>
            {WordSlide => <WordSlide height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WORD_RAIDERS:
        gameIconComponent = (
          <Bundle load={loadWordRaiders} showLoader={false}>
            {WordRaiders => <WordRaiders height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.ZOOM_BOOM:
        gameIconComponent = (
          <Bundle load={loadZoomBoom} showLoader={false}>
            {ZoomBoom => <ZoomBoom height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.SORT_IT_OUT:
        gameIconComponent = (
          <Bundle load={loadSortItOut} showLoader={false}>
            {SortItOut => <SortItOut height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.FIELD_OBSERVER:
        gameIconComponent = (
          <Bundle load={loadFieldObserver} showLoader={false}>
            {FieldObserver => <FieldObserver height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.YEARBOOK:
        gameIconComponent = (
          <Bundle load={loadYearbook} showLoader={false}>
            {Yearbook => <Yearbook height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.STORYLAB:
        gameIconComponent = (
          <Bundle load={loadStoryLabIcon} showLoader={false}>
            {StoryLabIcon => <StoryLabIcon height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.CODEX:
        gameIconComponent = (
          <Bundle load={loadCodex} showLoader={false}>
            {Codex => <Codex height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.WILD_PLANET:
        gameIconComponent = (
          <Bundle load={loadWildPlanet} showLoader={false}>
            {WildPlanet => <WildPlanet height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.VOCAB:
        gameIconComponent = (
          <Bundle load={loadVocab} showLoader={false}>
            {Vocab => <Vocab height={height} width={width} />}
          </Bundle>
        );
        break;
      case GameIds.BOOST_FLUENCY:
        gameIconComponent = (
          <Bundle load={loadBoostFluency} showLoader={false}>
            {BoostFluency => <BoostFluency height={height} width={width} />}
          </Bundle>
        );
        break;
      default:
        gameIconComponent = (
          <Bundle load={loadGameWIP} showLoader={false}>
            {GameWIP => <GameWIP height={height} width={width} />}
          </Bundle>
        );
    }
  }
  return <View>{gameIconComponent}</View>;
};

export default GameIcon;

GameIcon.defaultProps = {
  height: undefined,
  width: undefined,
  gameId: undefined,
};

GameIcon.propTypes = {
  height: PropTypes.any,
  width: PropTypes.any,
  gameId: PropTypes.any,
};
